import { render, staticRenderFns } from "./CategoryButton.vue?vue&type=template&id=27aa925d&scoped=true&"
import script from "./CategoryButton.vue?vue&type=script&lang=js&"
export * from "./CategoryButton.vue?vue&type=script&lang=js&"
import style0 from "./CategoryButton.vue?vue&type=style&index=0&id=27aa925d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa925d",
  null
  
)

export default component.exports